import axios, { InternalAxiosRequestConfig } from "axios";
import ProgressIndicator from "../../../components/widgets/ProgressIndicator/ProgressIndicator_model";
import PermissionsContext from "../../../contexts/permissions/PermissionsContext";
import OrganisationSettingsContext from "../../../contexts/organisationSettings/OrganisationSettingsContext";

const qs = require("qs");

const http = axios.create({
  baseURL: appConfig.flightPathCoreApiUrl,
  timeout: 300000,
  headers: {},
  paramsSerializer: function (params) {
    return qs.stringify(params, {
      encode: false
    });
  },
  withCredentials: true
});

export const ConfigureAxios = getAuthToken => {
  return new Promise((res, rej) => {
    const config = http.interceptors.request.use(
      async (config: InternalAxiosRequestConfig<any>) => {
        if (config.method !== "get") {
          ProgressIndicator.showTopProgressBarVisible();
        }
        try {
          const token = await getAuthToken();
          config.headers.Authorization = `Bearer ${token}`;
        } catch (error) {
          console.error("Error fetching token in interceptor:", error);
          // Optionally handle token errors
        }
        return config;
      },
      function (error) {
        return rej(error);
      }
    );
    res(config);
  });
};

http.interceptors.response.use(
  response => {
    ProgressIndicator.hideTopProgressBarVisible();
    onRequestReceived(response);
    return response;
  },
  error => {
    ProgressIndicator.hideTopProgressBarVisible();
    if (
      !!error.response &&
      !!error.response.data.error &&
      !!error.response.data.error.message &&
      error.response.data.error.details
    ) {
    } else if (!!error.response && !!error.response.data.error && !!error.response.data.error.message) {
    } else if (!error.response) {
    }

    setTimeout(() => {}, 1000);

    return Promise.reject(error);
  }
);

const onRequestReceived = result => {
  updatePermissions(result);
  updateOrganisationSettings(result);
};

const updatePermissions = result => {
  PermissionsContext.updateFromHeaders(result.headers["seren-insight-perv"], result.headers["seren-insight-per"]);
};

const updateOrganisationSettings = result => {
  OrganisationSettingsContext.updateFromHeaders(
    result.headers["seren-insight-osv"],
    result.headers["seren-insight-os"]
  );
};

export default http;
